import { MutableRefObject, useRef, useState } from "react";
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap";
import { Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { LinearKey } from "../../../Comps/LinearKey/LinearKey";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import './Hex.scss'
import { All } from "../../../Util/Constants/Quantities";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { NotePlayer } from "../../../Sound/NotePlayer";

export function Hex(props:ChapterConfig){
    const a:boolean = true
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div>
                <h1>The Hex Key</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const [hilitedNote, setHilitedNote] = useState<number>(-1)
    const notePlayer:NotePlayer = useNotePlayer()
    const [firstRoot, setFirstRoot] = useState(false)
    const getAdjustedHilitedNoteIndex = () => {
        if(hilitedNote !== 0){return hilitedNote}
        const index:number = (firstRoot) ? 0 : 7
        return index
    }
    const onNoteClick = (note:Note) => {
        if(!firstRoot && note.params.noteIndex === 0){
            notePlayer.reset()
        }
        notePlayer.playNote(note.params.tonic)
        setFirstRoot(!firstRoot)
        setHilitedNote(note.params.noteIndex)
    }
    const getSelectedNotes = () => {
        return (hilitedNote < 0) ? [] : [hilitedNote]
    }
    return(
        <OutlineBox title={'The Key of C in HexKey Form'} width={600}>
            <div className={'Hex Lesson'}>
                        <LinearKey tonic={Music.C} hilitedNote={getAdjustedHilitedNoteIndex()} repeatRoot={true}/>
                        <HxChildMap height={300} width={300} tonic={Music.C} radius={100} 
                            hilitedNotes={getSelectedNotes()} 
                            definedNotes={[All]}
                            singleSelect={true}
                            onNoteClick={onNoteClick}/>
                    </div>
        </OutlineBox>
    )
}
